import { Box, Center, Flex, Icon, IconButton } from '@chakra-ui/react'
import { Maximize2 } from 'react-feather'
import { useTranslation } from 'react-i18next'

interface OverlayProps {
  onClickLightbox?: () => void
}

// Must be placed within a containing `Box` with `position="relative"`
// `children` need to set `pointerEvents="auto"` on interactive elements
const Overlay: React.FC<OverlayProps> = ({ onClickLightbox, children }) => {
  const { t } = useTranslation()

  return (
    <Box position="absolute" bottom="0" w="full" h="12" pointerEvents="none">
      <Flex
        h="full"
        px="4"
        bg="overlayGradient"
        bgBlendMode="multiply"
        alignItems="center"
        justifyContent="flex-end"
      >
        <Box w="full">
          <Center>{children}</Center>
        </Box>
        {onClickLightbox ? (
          <Box pointerEvents="auto">
            <IconButton
              icon={<Icon as={Maximize2} color="white" boxSize="6" />}
              aria-label={t('image.lightboxButtonAriaLabel')}
              variant="ghost"
              onClick={onClickLightbox}
            />
          </Box>
        ) : null}
      </Flex>
    </Box>
  )
}

export default Overlay
